import { Injectable } from '@angular/core';
import { UserPointsRequest } from '@app/core/models';
import { BaseService, HttpOptions } from '@makiwin/ngx-drupal8-rest';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UserPointsService extends BaseService {
  /**
   * Add user points to entity, use negative numbers for remove.
   * @param type machine name of userpoints.
   * @param quantity amount of userpoints, negative numbers allowed.
   * @param entity_id entity id, ex for user its the uid.
   * @param log revision log message.
   * @param entity_type_id entity type machine name, default is `user`.
   * @returns backend response with the results.
   */
  add(type: string, quantity: number, entity_id: number, log?: string, entity_type_id?: string): Observable<any> {
    return this.requestEndpoint({
      op: 'add',
      type,
      quantity: quantity.toString(),
      entity_id: entity_id.toString(),
      log,
      entity_type_id,
    });
  }

  /**
   * Transfer points from entity to the target.
   * @param type machine name of userpoints.
   * @param quantity amount of userpoints, negative numbers allowed
   * @param entity_id entity target id, ex for user its the uid
   * @param target_entity_id target entity id
   * @param log revision log message
   * @param entity_type_id entity type machine name, default is `user`
   * @param target_entity_type_id target entity type machine name, default is `user`
   * @returns backend response with the results
   */
  transfer(
    type: string,
    quantity: number,
    entity_id: number,
    target_entity_id: number,
    log?: string,
    entity_type_id?: string,
    target_entity_type_id?: string
  ): Observable<any> {
    return this.requestEndpoint({
      target_entity_id: target_entity_id.toString(),
      op: 'add',
      type,
      quantity: quantity.toString(),
      entity_id: entity_id.toString(),
      entity_type_id,
      log,
      target_entity_type_id,
    });
  }

  /**
   * Get Quantity of points
   * @param type machine name of userpoints.
   * @param entity_id entity target id, ex for user its the uid
   */
  getQuantity(type: string, entity_id: number): Observable<number> {
    return this.requestEndpoint({
      op: 'getQuantity',
      type,
      entity_id: entity_id.toString(),
    });
  }

  /**
   * TODO
   */
  getLog(type: string, entity_id: number) {
    return this.requestEndpoint({
      op: 'getLog',
      type,
      entity_id: entity_id.toString(),
    });
  }

  /**
   * Request the backend userpoints endpoint
   * @param body content sent to the endpoint, check the userpoints custom module readme file
   * @returns backend response with the results
   */
  private requestEndpoint(body: UserPointsRequest) {
    const httpOptions: HttpOptions = {
      method: 'post',
    };
    return this.request(httpOptions, '/api/userpoints', body);
  }
}
